import React from 'react';

const MEMORY_PRESETS = [
  { label: '1 GB',  value: 1024 },
  { label: '2 GB',  value: 2048 },
  { label: '4 GB',  value: 4096 },
  { label: '8 GB',  value: 8192 },
  { label: '16 GB', value: 16384 },
];

function VMResizeModal({
  vm,
  vmid,
  resizeCores,
  resizeMemory,
  resizeSaving,
  resizeMsg,
  resizeNeedsReboot,
  onClose,
  onSubmit,
  onCoresChange,
  onMemoryChange,
  onDismissReboot,
  inline = false,
}) {
  const body = (
      <div className={`confirm-modal resize-modal${inline ? ' inline-panel' : ''}`} onClick={e => e.stopPropagation()}>
        <h3 className="confirm-title">⚙ Alterar CPU / Memória</h3>
        <p className="confirm-vm">VM: <strong>{vm?.name} (ID {vmid})</strong></p>

        {vm?.status === 'running' && (() => {
          const rawHp = String(vm.hotplug ?? '');
          const hpStr = rawHp === '1' ? 'network,disk,usb' : rawHp === '0' ? '' : rawHp;
          const hpItems = hpStr.split(',').map(s => s.trim());
          const hpCpu = hpItems.includes('cpu');
          const hpMem = hpItems.includes('memory');
          const numa  = !!vm.numa;
          const os    = vm.ostype || '';
          const osOk  = ['l26','l24','win2k8','win2k12','win2k16','win2k19','win2k22'].includes(os);
          const cpuLive = hpCpu && osOk;
          const memLive = hpMem && numa && osOk;

          if (cpuLive && memLive) return (
            <div className="resize-hotplug-ok">⚡ Hot-plug ativo — CPU e Memória serão aplicadas imediatamente</div>
          );
          if (cpuLive) return (
            <div className="resize-hotplug-partial">⚡ Hot-plug CPU ativo — Memória requer reboot{!hpMem ? ' (hotplug desabilitado)' : !numa ? ' (NUMA desabilitado)' : !osOk ? ' (SO incompatível)' : ''}</div>
          );
          if (memLive) return (
            <div className="resize-hotplug-partial">⚡ Hot-plug Memória ativo — CPU requer reboot{!hpCpu ? ' (hotplug desabilitado)' : !osOk ? ' (SO incompatível)' : ''}</div>
          );
          return (
            <div className="resize-running-warning">⚠ VM está rodando — alterações serão aplicadas após reboot</div>
          );
        })()}

        <div className="resize-field">
          <label className="resize-label">CPU (cores)</label>
          <input
            type="number"
            className="resize-input"
            value={resizeCores}
            onChange={e => onCoresChange(e.target.value)}
            min={1}
            max={128}
            disabled={resizeSaving}
          />
        </div>

        <div className="resize-field">
          <label className="resize-label">Memória (MB)</label>
          <input
            type="number"
            className="resize-input"
            value={resizeMemory}
            onChange={e => onMemoryChange(e.target.value)}
            min={512}
            max={131072}
            disabled={resizeSaving}
          />
          <div className="resize-presets">
            {MEMORY_PRESETS.map(p => (
              <button
                key={p.value}
                className={`resize-preset-btn${Number(resizeMemory) === p.value ? ' active' : ''}`}
                onClick={() => onMemoryChange(p.value)}
                disabled={resizeSaving}
              >
                {p.label}
              </button>
            ))}
          </div>
        </div>

        {resizeNeedsReboot && (
          <div className="resize-reboot-notice">
            ⚠ Alterações salvas. Reinicie a VM para aplicar.
          </div>
        )}

        {resizeMsg && (
          <div className={`resize-msg ${resizeMsg.type}`}>{resizeMsg.text}</div>
        )}

        <div className="confirm-actions">
          <button
            className="confirm-btn cancel"
            onClick={onClose}
          >
            Fechar
          </button>
          <button
            className="confirm-btn confirm action-btn resize-confirm"
            onClick={onSubmit}
            disabled={resizeSaving || (!resizeCores && !resizeMemory)}
          >
            {resizeSaving ? '⏳ Salvando...' : 'Aplicar'}
          </button>
        </div>
      </div>
  );
  if (inline) return body;
  return <div className="confirm-overlay" onClick={onClose}>{body}</div>;
}

export default VMResizeModal;
